var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPillBottle = function SvgPillBottle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pill-bottle_svgi__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.375 2.125h6.75v.75h-6.75zM1.187 1a.937.937 0 0 0-.937.938v1.125c0 .518.42.937.937.937h7.125c.518 0 .938-.42.938-.937V1.938A.937.937 0 0 0 8.312 1zM1 4.75v6.75c0 .828.672 1.5 1.5 1.5H7c.272 0 .525-.072.745-.196a4.1 4.1 0 0 1-.827-.929H2.5a.376.376 0 0 1-.375-.375v-.75h1.312a.561.561 0 1 0 0-1.125H2.125V8.5h1.312a.561.561 0 1 0 0-1.125H2.125V6.25h1.312a.561.561 0 1 0 0-1.125H2.125V4.75zm7.5 0H7.375v2.044A4.1 4.1 0 0 1 8.5 5.95zm1.875 2.625a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m0 5.625a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75M9.226 8.477a.56.56 0 0 0 0 .795l1.5 1.5a.562.562 0 0 0 .794-.795l-1.5-1.5a.56.56 0 0 0-.794 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pill-bottle_svgi__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgPillBottle;